import { makeSx } from '@saas/lib/shared-utils'
import { palette } from '@workspace/frontend-kit'

export default makeSx({
    LoggedUserHeader: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        flex: 1,
        gap: '1rem',
    },
    LoggedUserHeaderTriggerName: {
        textDecoration: 'none',
        fontWeight: 600,
        textAlign: 'right',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '1em',
        color: '#343434',
    },
    LoggedUserHeaderAutoNetworkTest: {
        marginRight: '1rem',
    },
    LoggedUserIconOutline: {
        width: '2.375rem',
        height: '2.375rem',
        border: `2px solid ${palette.typography[900]}`,
        borderRadius: '50%',
        alignItems: 'center',
        justifyContent: 'center',
    },
    LoggedUserIcon: {
        color: palette.typography[900],
        fontSize: '1.25rem',
    },
})
